var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import wait from 'root/src/shared/util/wait';
import { ActionStrategyId, GiveawayStatus } from '@daredrop-com/rewards-api-contract';
import { GiveawayWonModal } from 'root/src/client/web/giveaway/features/GiveawaySection/GiveawayWonModal';
import toast from 'react-hot-toast';
import { useEffect } from 'react';
import { useModal } from 'root/src/client/v2/common/contexts/modal.context';
import { useUserId } from 'root/src/client/v2/auth/hooks/useUserId';
import { useCreatorDataApi } from 'root/src/client/logic/api/hooks/useCreatorDataApi';
import { useBrowserNotification } from 'root/src/client/v2/common/hooks/useBrowserNotification';
import { GiveawayEvent } from 'root/src/client/web/giveaway/features/GiveawaySection/hooks/useSetupGiveawayListeners';
import { sortByDate } from 'root/src/shared/util/sortByDate';
export const useGiveawayLifecycle = () => {
    const modal = useModal();
    const { userId } = useUserId();
    const { fetchGiveaways } = useCreatorDataApi();
    const { sendNotification } = useBrowserNotification();
    const handleGiveawayFinished = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d;
        // wait until vouchers are created
        yield wait(1000);
        const result = yield fetchGiveaways();
        const finishedGiveaways = ((_b = (_a = result.body) === null || _a === void 0 ? void 0 : _a.giveaways) === null || _b === void 0 ? void 0 : _b.filter((giveaway) => {
            return giveaway.status === GiveawayStatus.Resolved || giveaway.status === GiveawayStatus.Stopped;
        })) || [];
        const [lastGiveaway] = sortByDate(finishedGiveaways, giveaway => { var _a; return (_a = giveaway.endDate) !== null && _a !== void 0 ? _a : new Date(0); });
        if (!lastGiveaway) {
            return;
        }
        const isWinner = (_d = (_c = lastGiveaway.vouchers) === null || _c === void 0 ? void 0 : _c.some) === null || _d === void 0 ? void 0 : _d.call(_c, voucher => voucher.owner.id === userId);
        const isEnterToGiveaway = lastGiveaway.actions.some((action) => {
            if (action.strategyId === ActionStrategyId.EnterGiveaway) {
                return action.entries.some(e => e.participantId === userId);
            }
            return false;
        });
        const isParticipant = isEnterToGiveaway && lastGiveaway.actions.some((action) => {
            if (action.strategyId === ActionStrategyId.EnterGiveawayTwitch
                || action.strategyId === ActionStrategyId.EnterGiveawayYoutube
                || action.strategyId === ActionStrategyId.EnterGiveawayTwitchSubscription) {
                return action.entries.some(e => e.participantId === userId);
            }
            return false;
        });
        const isGiveawayOwner = lastGiveaway.ownerId === userId;
        if (isGiveawayOwner || !isParticipant) {
            return;
        }
        if (isParticipant && lastGiveaway.status === GiveawayStatus.Stopped) {
            toast.error('Giveaway has cancelled by Creator!', {
                duration: 10000,
            });
            return;
        }
        if (isWinner) {
            void sendNotification({
                title: 'DareDrop - You Won!',
                body: 'Congratulations! You won the giveaway!',
            });
            modal.show(<GiveawayWonModal />);
            return;
        }
        toast.success('Giveaway has finished. You were not lucky this time, better luck next time! 🫡', {
            duration: 30000,
        });
    });
    useEffect(() => {
        window.addEventListener(GiveawayEvent.Ended, handleGiveawayFinished);
        return () => {
            window.removeEventListener(GiveawayEvent.Ended, handleGiveawayFinished);
        };
    }, []);
};
